/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Visibility level for sharing user information
 * @export
 */
export const InternalCommonSharingVisibility = {
    WithAdmin: 'with_admin',
    WithAll: 'with_all',
    WithBookmarkedUsers: 'with_bookmarked_users'
};
export function instanceOfInternalCommonSharingVisibility(value) {
    for (const key in InternalCommonSharingVisibility) {
        if (Object.prototype.hasOwnProperty.call(InternalCommonSharingVisibility, key)) {
            if (InternalCommonSharingVisibility[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function InternalCommonSharingVisibilityFromJSON(json) {
    return InternalCommonSharingVisibilityFromJSONTyped(json, false);
}
export function InternalCommonSharingVisibilityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InternalCommonSharingVisibilityToJSON(value) {
    return value;
}
export function InternalCommonSharingVisibilityToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
